import { useTranslation } from 'react-i18next';
import { useActiveConversation } from '../../contexts/ActiveConversationContext';
import { useTheme } from '../../contexts/ThemeContext';
import { ChatHeader } from '../layout/ChatHeader';
import { Composer } from './Composer';
import { MessageList } from './MessageList';

const GREETING_KEYS: Record<string, string> = {
  morning: 'greetingMorning',
  afternoon: 'greetingAfternoon',
  evening: 'greetingEvening',
};

export function ChatMain() {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const { conversationId, messages, loading, runError, runState } = useActiveConversation();

  const isFreshNew = conversationId === null && messages.length === 0 && runState === 'idle';

  return (
    <div className="chat-main">
      <ChatHeader />

      {loading ? (
        <div className="loading-screen">{t('loading')}</div>
      ) : isFreshNew ? (
        <div className="welcome-state">
          <div className="welcome-logo">Z</div>
          <div className="welcome-title">{t('welcomeTitle')}</div>
          <div className="welcome-sub">{t('welcomeSub')}</div>
          <div className="welcome-greeting">{t(GREETING_KEYS[theme] ?? 'greetingMorning')}</div>
        </div>
      ) : (
        <MessageList />
      )}

      {runError && <div className="run-error">{runError}</div>}

      <Composer />
    </div>
  );
}
